// based on "Airgloss standard" profile
const colorProfiles = {
    iaq: [0, 150, 250, 400],
    voc: [0, 1700, 2600, 4000],
    co: [0, 30, 50, 80],
    ch4: [0, 2400, 4000, 6500],
    no2: [0, 600, 1000, 1500],
    co2: [0, 1100, 1600, 2600],
    temp: [0, 18, 32, 40],
    humi: [0, 33, 67, 100],
    sound: [30, 60, 70, 100],
    press: [900, 1000, 1100, 1200],
};

export function getColorDots(sensorTypeName, value) {
    if (!(sensorTypeName in colorProfiles)) {
        return 0;
    }

    const [min, warning, danger, max] = colorProfiles[sensorTypeName];
    if (value < min) {
        return 0
    } else if (value < warning) {
        return Math.ceil((value - min) * 5 / (warning - min))
    } else if (value < danger) {
        return Math.ceil((value - warning) * 5 / (danger - warning)) + 5
    } else if (value < max) {
        return Math.ceil((value - danger) * 5 / (max - danger)) + 10
    }

    return 15;
}

export function getColor(sensorTypeName, dots) {
    if (sensorTypeName === 'press') {
        return 'good'
    }

    if (sensorTypeName === 'temp' ||  sensorTypeName === 'humi') {
        if (dots > 5 && dots <= 10) {
            return 'good'
        }

        return 'warning'
    }

    if (dots <= 5) {
        return 'good'
    } else if (dots <= 10) {
        return 'warning'
    } else {
        return 'danger'
    }
}
